// Agreed agency package pricing (all amounts AUD, all inclusive).
const form2Standard = 990;
const amlStandardPerPerson = 77;
const amlPeople = 2;
const standardTotalAml = amlStandardPerPerson * amlPeople;

export const AGENCY_PACKAGE = {
  price: 799,
  form2Standard,
  amlStandardPerPerson,
  amlPeople,
  standardTotal: standardTotalAml,
  saving: form2Standard + standardTotalAml - 799,
} as const;
export const FNM_PACKAGE = AGENCY_PACKAGE;

export const FNM_PAYMENT_TERMS = {
  paymentDueWithinDays: 30,
  contractObtainedWithinDays: 30,
} as const;

export const FNM_PAYMENT_DESCRIPTION = `Payment due within ${FNM_PAYMENT_TERMS.paymentDueWithinDays} days. If you obtain a contract within ${FNM_PAYMENT_TERMS.contractObtainedWithinDays} days, payment can be deferred until settlement.`;
